var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "boss-agreement-headline-container clearfix" },
    [
      _c("div", { staticClass: "boss-agreement-headline-wrap" }, [
        _c("div", { staticClass: "float-left boss-agreement-left" }, [
          _c("div", { staticClass: "boss-agreement" }, [
            _vm._v(
              "\n        掲載期間 ｜ " +
                _vm._s(_vm.firstDate) +
                "〜" +
                _vm._s(_vm.lastDate) +
                "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.isPublished
          ? _c("div", { staticClass: "float-right boss-agreement-right" }, [
              _c("div", { staticClass: "boss-agreement-right-container" }, [
                _c(
                  "div",
                  { staticClass: "boss-agreement-right-wrap clearfix" },
                  [
                    _c(
                      "div",
                      { staticClass: "float-left boss-agreement-right-item" },
                      [
                        _c("div", {
                          staticClass: "boss-icon boss-icon-scout boss-scout",
                        }),
                        _vm._v(" "),
                        _c("span", { attrs: { "data-test": "scout-count" } }, [
                          _vm._v(
                            "スカウト残数：" +
                              _vm._s(
                                _vm.remainingScoutAmount.toLocaleString()
                              ) +
                              "通／" +
                              _vm._s(_vm.scoutLimit.toLocaleString()) +
                              "通"
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.reservedScoutFirstSendAmount
                          ? _c(
                              "span",
                              { attrs: { "data-test": "reserved-count" } },
                              [
                                _vm._v(
                                  "（予約" +
                                    _vm._s(
                                      _vm.reservedScoutFirstSendAmount.toLocaleString()
                                    ) +
                                    "名含む）"
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]
                ),
              ]),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }